import { State } from '@/store/store'
export interface PaymentList {
  column: Array<{
    text: string
    value: string
    type?: string
    options?: {
      orderable?: boolean
      lengthLimit?: number
      filter?: boolean
      operation: string[],
    },
  }>
  defaultFilter: object
  itemCount: number
  page: number
  pageCount: number
  result: Array<{
    _id: string,
    name?: string,
    centerId: string,
    centerName?: string,
    accountNumber: string,
    bank: string,
    createdAt?: number,
    updatedAt?: number,
  }>
}

export class PaymentState {
  public list: PaymentList
  constructor() {
    this.list = {
      column: [],
      itemCount: 0,
      page: 1,
      pageCount: 1,
      result: [],
      defaultFilter: {},
    }
  }
}

export interface IPayment {
  _id: string,
  name?: string,
  centerId: string,
  accountNumber: string,
  bank: string,
  createdAt?: number,
  updatedAt?: number,
}

export default PaymentState
